/**
 * Utility functions for working with pages.
 *
 * These are kept separate from the page utils module because they are used by selectors
 * and we want to avoid circular dependencies.
 */

import { InteractionMode, type PageType } from "components/server-types";

export type GroupInteractionModeType =
  | InteractionMode.ASSIGN_STUDENTS
  | InteractionMode.SELF_ASSIGN;

export const GROUP_INTERACTION_MODES = [
  InteractionMode.ASSIGN_STUDENTS,
  InteractionMode.SELF_ASSIGN,
];

export const isSharedClassInteractionMode = (interactionMode: InteractionMode | undefined) =>
  interactionMode === InteractionMode.SHARED_CLASS;

export const isSharedClassPage = (page?: PageType | null) =>
  isSharedClassInteractionMode(page?.interaction_mode);

export const isGroupInteractionMode = (interactionMode: InteractionMode | undefined) =>
  !!interactionMode && GROUP_INTERACTION_MODES.includes(interactionMode);

export const isGroupPage = (page: PageType | null) =>
  isGroupInteractionMode(page?.interaction_mode);

export const isIndividualPage = (page: PageType | null) =>
  page?.interaction_mode === InteractionMode.INDIVIDUAL;

export const isStaticPage = (page: PageType | null) =>
  page?.interaction_mode === InteractionMode.STATIC;
